import React, { Fragment, useEffect, useState, useRef } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  faImage,
  faPaperclip,
  faSmile,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import MsgDataService from "../../services/MsgService";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Check from "@mui/icons-material/Check";
import Clear from "@material-ui/icons/Clear";
import { useSelector } from "react-redux";

// Modern icon imports like SingleCounselorMessage
import galleryIcon from "../../assets/images/CouselorMessages/SingleChat/gallary.png";
import attachmentIcon from "../../assets/images/CouselorMessages/SingleChat/attachment.png";
import smileIcon from "../../assets/images/CouselorMessages/SingleChat/simile.png";
import checkmarkIcon from "../../assets/images/CouselorMessages/SingleChat/Checkmark.png";
import checkmarkselected from "../../assets/images/CouselorMessages/SingleChat/Checkmark Selected.png";
import sendIcon from "../../assets/images/CouselorMessages/SingleChat/send.png";
import leftAvatar from "../../assets/images/CouselorMessages/SingleChat/left.png";
import rightAvatar from "../../assets/images/CouselorMessages/SingleChat/right.png";

const API_URL = process.env.REACT_APP_API_URL;
const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const SingleMessage = ({
  msgData,
  isStudentOrCounselor,
  setShowSingleMessageComponent,
  conversition,
  getMsgData,
}) => {
  console.log("msgData from the single message", msgData);
  const ref = useRef();

  // Function to convert URLs in text to clickable links
  const renderMessageWithLinks = (text) => {
    if (!text) return "";
    
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    
    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1395F2", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const [msg, setMsg] = useState([msgData]);
  const [msgValue, setMsgValue] = useState();
  const [cannedMsgData, setCannedMsgData] = useState([]);
  const [openAccordion, setOpenAccordion] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedfile, setSelectedFile] = useState();
  const [fileDataFromApi, setFileDataFromApi] = useState();
  const [selected, setSelected] = useState();

  const messageInputHandler = (e) => {
    setMsgValue(e.target.value);
  };

  // const handleFileChange = async (e) => {
  //   await setSelectedFile(ref.current.files[0]);
  // };
  const handleFileChange = async (e) => {
    // setSelectedFile(ref.current.files[0]);
    await getAttachment();
  };

  const sendCopyToParents = () => {
    setSelected(!selected);
  };

  // const submitAttachment = async () => {
  //   MsgDataService.attachment(selectedfile)
  //     .then((data) => {
  //       console.log("data from attachment", data);
  //       setFileDataFromApi(data.data);
  //       ref.current.value = "";
  //     })
  //     .catch((err) => console.log(err));
  // };

  const token = useSelector((state) => state.UserReducer.userObj.token);
  const userObj = useSelector((state) => state.UserReducer.userObj);

  const getAttachment = () => {
    let selectedfile = ref.current.files[0];
    console.log("selectedFile", selectedfile);
    const formData = new FormData();
    formData.append("message_file", selectedfile);
    // formData.append("is_message", true);
    fetch(`${API_URL}/api/recruiter/message_attachment/`, {
      method: "POST",
      body: formData,
      headers: {
        "x-authorization": `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("data from attachment", data);
        setFileDataFromApi(data);
        ref.current.value = "";
      })
      .catch((error) => {
        console.log("error from the error", error);
      });
  };

  const deleteAttachment = () => {
    let body ={
      message_file:fileDataFromApi?.Status?.image_name
    }
    MsgDataService.deleteattachment(body)
      .then((data) => {
        setFileDataFromApi();
      })
      .catch((error) => console.log("error from the service", error));
  };

  // useEffect(() => {
  //     submitAttachment()
  // }, [selectedfile])

  // Scheduled templates
  const getCannedMsgData = () => {
    MsgDataService.getCannedMsgPage('recruiter', userObj?.college, page)
      .then(data => setCannedMsgData(data?.data?.result || []))
      .catch(() => setCannedMsgData([]));
  };
  const accordionHandler = () => {
    const next = !openAccordion;
    setOpenAccordion(next);
    if (next && (!cannedMsgData || cannedMsgData.length === 0)) {
      getCannedMsgData();
    }
  };
  const selectTemplate = (item) => {
    setOpenAccordion(false);
    setMsgValue(item?.messages?.en?.body || "");
  };

  const sendMessage = (e) => {
    if (msgValue === "" || msgValue.trim() === "" || msgValue === "undefined") {
      e.preventDefault();
    }
    else{
    let obj = {
      // answers: [],
      message_body: msgValue,
      dst_id: [msgData?.src_id],
      event_type:
      isStudentOrCounselor === "counselors"
      ? "recruiter_counselor"
      : isStudentOrCounselor === "students"
      ? "recruiter_student"
      : isStudentOrCounselor === "international-students"
      ? "international_student"
      : null,
      // student: [msgData && msgData && msgData.student.id],
    };
    if(isStudentOrCounselor === "international-students"){
      obj.is_international = true;
    }
    if (selected) {
      obj.parent_ack = selected;
    }
    console.log("fileData",fileDataFromApi);
    if (fileDataFromApi) {
      obj.attachment_url= fileDataFromApi?.Status?.image_name;
    }
    MsgDataService.sendMessage(obj)
      .then((data) => {
        // setMsg()
        setSelected(false);
        setShowSingleMessageComponent(false);
        setMsgValue();
        getMsgData();
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  }}

 

  // const getMessageData = (item) => {
  //   return item && item.body;
  // };

  // const getMessageDate = (item) => {
  //   return moment(item && item.date_sent).format("ddd MMM Do YYYY, hh:mm:ss a");
  // };

  // const senderName = (item) => {
  //   let name;
  //   name = item && item.src_id && item.src_id.name;
  //   return name;
  // };

  useEffect(() => {
    // let msg = Object.values(msgData.messages);
    setMsg(msg);
    // getMessageData();
    // getMessageDate();
    // senderName();
  }, [msgData]);

  console.log("msgData 88", conversition);

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    scrollContainerRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  })

  return (
    <Fragment>
      <div style={{ width: '100%', background: 'transparent', boxShadow: 'none' }}>
        <p
          style={{
            marginBottom: "0px",
            padding: "10px 15px",
            fontWeight: "bold",
          }}
        >
          {`Conversation with ${msgData?.name}`}
        </p>
        
        <div
          className="singlemessage"
          style={{
            border: '2px solid #0046A0',
            borderRadius: '12px',
            background: '#FFFFFF',
            padding: '18px 10px',
            maxHeight: '500px',
            overflowY: 'auto',
            marginTop: '15px'
          }}
        >
          {conversition &&
            conversition.map((item, index) => {
              console.log("item from msg", item);
              const isReceived = item.src_name === msgData?.name; // received from other party
              const isLast = index === conversition.length - 1;
              const containerProps = { 
                key: index, 
                style: { margin: "12px 15px 20px", background: "#fff" } 
              };
              if (isLast) containerProps.ref = scrollContainerRef;
              
              return (
                <div {...containerProps}>
                  {/* Header Row: time + name + avatar positioned based on direction */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 12,
                    }}
                  >
                    {isReceived ? (
                      // Avatar + name left, time right
                      <>
                        <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
                          <img
                            src={item?.profile_image || IMG_URL + "placeholder.jpg"}
                            alt="avatar"
                            style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                          />
                          <p style={{ fontWeight: 600, margin: 0 }}>{item.src_name}</p>
                        </div>
                        <p
                          className="date"
                          style={{
                            margin: 0,
                            fontSize: 12,
                            color: "#006400",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {moment(item.date_sent).format("ddd MMM Do YYYY, hh:mm:ss a")}
                        </p>
                      </>
                    ) : (
                      // Time left, name + avatar right
                      <>
                        <p
                          className="date"
                          style={{
                            margin: 0,
                            fontSize: 12,
                            color: "#006400",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {moment(item.date_sent).format("ddd MMM Do YYYY, hh:mm:ss a")}
                        </p>
                        <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, justifyContent: "flex-end" }}>
                          <p style={{ fontWeight: 600, margin: 0 }}>{item.src_name}</p>
                          <img
                            src={IMG_URL + "placeholder.jpg"}
                            alt="avatar"
                            style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  
                  {/* Body Row */}
                  <div style={{ marginTop: 10 }}>
                    <div
                      style={{
                        fontSize: "14px",
                        whiteSpace: "pre-wrap",
                        lineHeight: "1.6",
                        textAlign: "justify",
                        wordWrap: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      {renderMessageWithLinks(item.message_body)}
                    </div>
                    {item?.attachment_url && (
                      <div style={{ marginTop: 8 }}>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={item?.attachment_url}
                          style={{ display: "inline-block" }}
                        >
                          {item?.attachment_url ? "Download Attachment" : " "}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>

        <div style={{
            border: '2px solid #0046A0',
            borderRadius: '12px',
            background: '#FFFFFF',
            padding: '18px 15px',
            marginTop: '25px'
          }}>
          <div style={{ marginBottom:'14px' }}>
            <div
              role="button"
              tabIndex={0}
              onClick={accordionHandler}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && accordionHandler()}
              style={{
                width: '100%',
                background: '#FFFFFF',
                border: '2px solid #0046A0',
                borderRadius: 18,
                padding: '10px 14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontWeight: 700,
                color: '#006400',
                cursor: 'pointer'
              }}
            >
              <span>Choose a Scheduled Message Template</span>
              <span style={{ transform: openAccordion ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform .2s ease' }}>
                <KeyboardArrowDownIcon style={{ color: '#006400' }} />
              </span>
            </div>
            {openAccordion && (
              <div style={{
                background: '#FFFFFF',
                border: '1px solid #D0E4F1',
                borderRadius: 14,
                maxHeight: 260,
                overflowY: 'auto',
                marginTop: 8,
                padding: 8
              }}>
                {Array.isArray(cannedMsgData) && cannedMsgData.length > 0 ? (
                  cannedMsgData.map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => selectTemplate(item)}
                      style={{
                        border: '1px solid #E7F2FA',
                        borderRadius: 12,
                        padding: '10px 12px',
                        margin: '8px 6px',
                        cursor: 'pointer',
                        background: '#F9FCFF'
                      }}
                    >
                      <div style={{ fontWeight: 700, color: '#0F2434', marginBottom: 6 }}>
                        {item?.messages?.en?.subject || 'Untitled'}
                      </div>
                      <div style={{ color: '#406079', fontSize: 14, whiteSpace: 'pre-wrap' }}>
                        {item?.messages?.en?.body}
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: 12, color: '#406079' }}>No templates available.</div>
                )}
              </div>
            )}
          </div>
          <textarea
            rows="6"
            cols="30"
            className="textAreaInput"
            placeholder="Or type your message..."
            onChange={messageInputHandler}
            value={msgValue}
            style={{ border:'2px solid #0046A0', borderRadius:'18px', padding:'14px 18px', resize:'vertical', fontSize:'14px', lineHeight:'1.5' }}
          />
          <div
            className="reply-container-mobile"
            style={{
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '18px 5px 0 5px',
              flexWrap: 'wrap'
            }}
          >
            <div
              className="reply-container-mobile"
              style={{ alignItems: 'center', flexWrap:'wrap', gap:'18px' }}
            >
              {/* Action Icons */}
              <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
                {/* <div style={{ cursor:'pointer', width:46, height:46, borderRadius:'12px', background:'#E5F4E4', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <img src={galleryIcon} alt="gallery" style={{ width:28, height:28 }} />
                </div> */}
                <div style={{ cursor:'pointer', width:46, height:46, borderRadius:'12px', background:'#E5F4E4', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <label htmlFor="fileUploader" style={{ cursor:'pointer', margin:0, display:'flex' }}>
                    <img src={attachmentIcon} alt="attachment" style={{ width:26, height:26 }} />
                  </label>
                </div>
                {/* <div style={{ cursor:'pointer', width:46, height:46, borderRadius:'12px', background:'#E5F4E4', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <img src={smileIcon} alt="emoji" style={{ width:28, height:28 }} />
                </div> */}
              </div>
              {isStudentOrCounselor === "students" || isStudentOrCounselor === "international-students" ? (
                <div style={{ display:'flex', alignItems:'center', gap:5 }}>
                  <div
                    onClick={sendCopyToParents}
                    style={{
                      cursor:'pointer',
                      width:54,
                      height:54,
                      borderRadius:'50%',
                      display:'flex',
                      alignItems:'center',
                      justifyContent:'center',
                      transition:'all .25s ease'
                    }}
                  >
                    <img
                      src={selected ? checkmarkselected : checkmarkIcon}
                      alt={selected ? 'checked' : 'unchecked'}
                      style={{ width:28, height:28 }}
                    />
                  </div>
                  <span
                    onClick={sendCopyToParents}
                    style={{ cursor:'pointer', fontSize:14, fontWeight:500 }}
                  >
                    Send copy to parent
                  </span>
                </div>
              ) : null}
              <input id="fileUploader" type="file" ref={ref} onChange={handleFileChange} style={{ display:'none' }} />
              {fileDataFromApi && (
                <div
                  className="reply-container-gap"
                  style={{ alignItems: 'center', display:'flex', gap:6 }}
                >
                  <p style={{ color: "#008000", marginBottom: "0px" }}>
                    {fileDataFromApi &&
                      fileDataFromApi?.Status?.filename.slice(0, 15)}
                  </p>
                  <div
                    onClick={deleteAttachment}
                    style={{ cursor: "pointer" }}
                  >
                    <Clear className="cancelAttachment" />
                  </div>
                </div>
              )}
            </div>
            <button
              onClick={sendMessage}
              className="sendmessage reply-container-gap"
              style={{
                background:'#1395F2',
                border:'3px solid #FFFFFF',
                color: '#FFFFFF',
                padding:'14px 34px',
                borderRadius:'18px',
                fontSize:'16px',
                fontWeight:600,
                display:'flex',
                alignItems:'center',
                gap:10,
                boxShadow:'0 0 0 2px #1395F2',
                cursor: !msgValue ? 'not-allowed' : 'pointer'
              }}
              disabled={!msgValue}
            >
              <img src={sendIcon} alt="send" style={{ width:22, height:22 }} />
              Send Message
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default SingleMessage;
